"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageWithSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ImageWithSkeleton = (param)=>{
    let { src, alt } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const fallback = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ImageSkeleton, {
            animation: "wave",
            variant: "rectangular"
        }), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Image, {
        alt: alt,
        src: src,
        fallback: fallback,
        "data-testid": getTestId(_constants.IMAGE_WITH_SKELETON)
    });
};
exports.ImageWithSkeleton = ImageWithSkeleton;
